import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
import ViewUI from 'view-design'
import store from '../store'
import { session, cookie } from '../libs/location'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history',
  base: '/qc-portal/'
})

router.beforeEach((to, from, next) => {
  ViewUI.LoadingBar.start()
  if (to.query.token) {
    session.setObject(to.query.token)
    cookie.setCookie('token', to.query.token)
  }
  let token = session.getItem('token')
  document.title = to.meta.title
  if (to.name === 'resetPassword' || to.name === 'error_scanerror' || to.name === 'autoLoginDD' || to.name === 'autoLoginPC' || to.name === 'loginBack') {
    next()
  } else {
    store.dispatch('doGetSetting').then(data => {
      if (token) {
        // 设置语言和皮肤
        if (session.getItem('userInfo')) {
          store.dispatch('doChangeSkin', JSON.parse(session.getItem('userInfo')).skinColor)
        }
        if (to.path === '/' || to.path === '/login') {
          if (!window.document.location.origin.includes('hello.')) {
            next({ name: 'home' })
          } else {
            next({ name: 'home_old' })
          }
        } else {
          next()
        }
      } else {
        if (to.path === '/' || to.path === '/login' || to.path === '/link') {
          next()
        } else {
          next({ name: 'login' })
        }
      }
    })
  }
})

router.afterEach(to => {
  ViewUI.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
